import { render, staticRenderFns } from "./GameItemsListCard.vue?vue&type=template&id=a5973964&scoped=true&"
import script from "./GameItemsListCard.vue?vue&type=script&lang=js&"
export * from "./GameItemsListCard.vue?vue&type=script&lang=js&"
import style0 from "./GameItemsListCard.vue?vue&type=style&index=0&id=a5973964&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5973964",
  null
  
)

export default component.exports